module.exports = __webpack_public_path__ + "img/環保標章.fed51955.jpg";